import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DatePicker } from "@mui/x-date-pickers";
import { TimeService, getMomentTz } from "@dexteel/mesf-core";

const moment = getMomentTz();

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiFormHelperText-filled": {
			display: "none",
		},
	},
	inputEditable: {
		"& .MuiOutlinedInput-root": {
			backgroundColor: "#ffffff",
			"& .MuiOutlinedInput-notchedOutline": {
				border: "1px solid #C4C4C4",
			},
		},
	},
	inputError: {
		"& .MuiOutlinedInput-root": {
			backgroundColor: "#ffffff",
			"& .MuiOutlinedInput-notchedOutline": {
				border: "2px solid #f44336",
			},
		},
	},
}));

interface ComparisonStartFilterProps {
	start: Date;
	end?: Date;
	onStartChange: (date: Date) => void;
	error?: boolean;
}

export const ComparisonStartFilter: React.FC<ComparisonStartFilterProps> = ({
	start,
	end,
	onStartChange,
	error,
}) => {
	const classes = useStyles();

	const handleDateChange = (date: any) => {
		if (date && moment(date).isValid()) {
			onStartChange(moment(date).toDate());
		}
	};

	const today = moment().endOf("day");
	const maxDate = end ? moment(end).subtract(1, "day") : today;

	return (
		<div className={classes.root}>
			<DatePicker
				label="Start Date"
				timezone={TimeService.getInstance().getServerTimeZone()}
				format="MM/DD/YYYY"
				value={moment(start) as any}
				onChange={handleDateChange}
				maxDate={maxDate as any}
				slotProps={{
					textField: {
						fullWidth: true,
						variant: "outlined",
						className: error ? classes.inputError : classes.inputEditable,
						InputProps: {
							style: {
								height: "38px",
								marginTop: 8,
							},
						},
						InputLabelProps: {
							style: {
								marginTop: "8px",
								fontSize: "14px",
							},
						},
					},
				}}
			/>
		</div>
	);
};
